import { Fragment, FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { OverlayPanel } from "primereact/overlaypanel";

import { faArrowRightFromBracket, faGear, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../models/app-translation-keys";
import { RouteConstants } from "../../../../models/enums";
import { useStore } from "../../../../stores/StoreContext";

import "./UserProfile.scss";

import { AppRole } from "../../../../../@api";

import { appVersion } from "../../../../../environmentConfiguration";

export const UserProfile: FunctionComponent = () => {
  const { t } = useTranslation();
  const { userStore, permissionStore } = useStore();
  const navigate = useNavigate();

  const userProfileOverlayPanelRef = useRef<OverlayPanel>(null);

  const toggleUser = (event: any) => {
    if (userProfileOverlayPanelRef.current) {
      userProfileOverlayPanelRef.current.toggle(event);
      userProfileOverlayPanelRef.current.align();
    }
  };

  const navigateTo = (event: any, path: RouteConstants) => {
    navigate(path.startsWith("/") ? path : `/${path}`);
    userProfileOverlayPanelRef.current?.hide();
  };

  return (
    <Fragment>
      <button
        className="unstyled-button user-profile"
        type="button"
        title={userStore.userInfo?.displayName}
        onClick={event => toggleUser(event)}
      >
        <FontAwesomeIcon icon={faUser} />
      </button>

      <OverlayPanel ref={userProfileOverlayPanelRef} className="user-panel">
        <ul className="user-panel-list">
          <li className="user-name">{userStore.userInfo?.displayName}</li>

          {permissionStore.hasAnyRole([
            AppRole.UserManagementAdmin,
            AppRole.LegalInformationAdmin,
            AppRole.ContentManagementAdmin,
            AppRole.AppCustomizationAdmin,
            AppRole.GlossaryAdmin,
          ]) && (
            <li
              className="link"
              onClick={event => navigateTo(event, RouteConstants.AdminArea)}
              onKeyDown={event => event.key === "Enter" && navigateTo(event, RouteConstants.AdminArea)}
              tabIndex={0}
            >
              <div className="link-icon-text">
                <FontAwesomeIcon icon={faGear} />

                <span>{t(translationKeys.navigation.goToAdminArea)}</span>
              </div>
            </li>
          )}

          <li
            className="link"
            onClick={event => navigateTo(event, RouteConstants.Logout)}
            onKeyDown={event => event.key === "Enter" && navigateTo(event, RouteConstants.Logout)}
            tabIndex={0}
          >
            <div className="link-icon-text">
              <FontAwesomeIcon icon={faArrowRightFromBracket} />

              <span>{t(translationKeys.global.logout)}</span>
            </div>
          </li>
        </ul>
        <div className="version-info">{appVersion}</div>
      </OverlayPanel>
    </Fragment>
  );
};
